export function isInteger(value: number) {
	if (Number.isInteger) return Number.isInteger(value);
	return isFinite(value) && Math.floor(value) === value;
}
